/// <amd-module name="VSS/Diagnostics/UI/Components/Feedback/Feedback" />
import * as React from "react";

import { Components, WrappedComponent } from "VSS/Platform/Layout";

import { Section } from "VSS/Diagnostics/UI/Section";

interface FeedbackState {
    showPerfFeedbackDialog: boolean;
}

class Feedback extends React.Component<{}, FeedbackState> {
    public state = { showPerfFeedbackDialog: false };

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <Section key="feedback-section" sectionLabel="Perf Feedback" onClick={this.showPerfFeedbackDialog} />
                {this.state.showPerfFeedbackDialog ? (
                    <WrappedComponent
                        dependencies={["ms.vss-features.diag-dialog-content"]}
                        wrappedType="vss.perf-feedback-dialog"
                        onDismiss={this.hidePerfFeedback}
                    />
                ) : null}
            </React.Fragment>
        );
    }

    private hidePerfFeedback = () => {
        this.setState({ showPerfFeedbackDialog: false });
    };

    private showPerfFeedbackDialog = () => {
        this.setState({ showPerfFeedbackDialog: true });
    };
}

Components.add("perfbar.feedbackSection", Feedback);

class Filler extends React.Component<{}> {
    public render(): JSX.Element {
        return <div className="flex-grow" />;
    }
}

Components.add("perfbar.fillerSection", Filler);
